import { GET_SEARCH_VALUE } from './types';

export const getSearchValueAction = (searchValue) => dispatch => {
    dispatch({
        type: GET_SEARCH_VALUE,
        searchValue: searchValue,
    })
}